// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card_3XeU3","head":"index_head_3y7ZX","left":"index_left_KRFcp","right":"index_right_1MIWE"};